import React, {useState, useEffect} from 'react';
import Navbar1 from './Navbar1';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    doc,
    getDoc,
    serverTimestamp,
    setDoc
  } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from 'react-toastify';
import { reset } from '../../features/auth/authSlice';
import config from '../../config';
import Sidebar from './Sidebar';
import Spinner from '../Spinner';

var url = config.nav.url;

var step1 = url+'step1';
var dashboard_link = url+'dashboard';
var step3 = url+'step3';

let id = '';

const Step2 = () => {
    const { t } = useTranslation();
    if(localStorage.getItem('id') != null){
        id = localStorage.getItem('id');
    }
    var today = Date();
    var lastDay = '01/30/2023';
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const type = localStorage.getItem("type");
    const [form, setError] = useState({
        error: false,
    });

    const [page, setUpdated] = useState({
        updated: false,
    });

    const [isLoading, setIsLoading] = useState(false);

    const [status, setEnabled] = useState({
        submitted: false,
    });

    const [deadline, setDeadline] = useState({
        isPassed: true,
        value: true
    });

    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });

    const [step, setStep] = useState({
        title : '',
        titleShort : '',
        resume: '',
        context: '',
        objective: '',
        result: '',
        amount: '',
        duration : ''
    });

    const [res, setResWord] = useState({
        count: 0
    });
    
    const resWordCount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        
        res.count = value.trim().split(' ').length;
        if(500 - res.count < 0){
            form.error = true;
            setError({...form, [form]:true})
        }
        else{
            form.error = false;
            setError({...form, [form]:false})
        }
        setResWord({...res, [name]:value})
    }

    const [ctx, setCtxWord] = useState({
        count: 0
    });
    
    const contextWordCount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        
        ctx.count = value.trim().split(' ').length;
        if(1500 - ctx.count < 0){
            form.error = true;
            setError({...form, [form]:true})
        }
        else{
            form.error = false;
            setError({...form, [form]:false})
        }
        setCtxWord({...ctx, [name]:value})
    }

    const [obj, setObjWord] = useState({
        count: 0
    });
    
    const objWordCount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        
        obj.count = value.trim().split(' ').length;
        if(1000 - obj.count < 0){
            form.error = true;
            setError({...form, [form]:true})
        }
        else{
            form.error = false;
            setError({...form, [form]:false})
        }
        setObjWord({...obj, [name]:value})
    }

    const [res2, setRes2Word] = useState({
        count: 0
    });
    
    const res2WordCount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        
        res2.count = value.trim().split(' ').length;
        if(1000 - res.count < 0){
            form.error = true;
            setError({...form, [form]:true})
        }
        else{
            form.error = false;
            setError({...form, [form]:false})
        }
        setRes2Word({...res2, [name]:value})
    }

    const getStatus = async () => {
        try {
            const userRef = doc(db, "submissions", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists()){
                status.submitted = true;
                setEnabled({...status, [status]:true})
            }
            
        } catch (error) {
            console.log(error);
        }
    };

    const getStepDetails = async () => {
        try {
            const stepRef = doc(db, "step2", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                window.alert('Pas de connexion internet')
            }
            else{
                window.alert(error)
            }
        }
    };

    const { stp, isError, isSuccess, message} = useSelector(
        (state) => state.auth
      )

    useEffect(() => {
        // restrict access for examinators
        if(type === 'exam'){
            navigate('/admin')
        }

        // getting step details
        if(firstRender){
            deadline.isPassed = Date.parse(today) > Date.parse(lastDay);
            deadline.value = Math.round((Date.parse(lastDay) - Date.parse(today)) / (1000 * 60 * 60 * 24));
            setDeadline(deadline);

            getStatus();
            getStepDetails().then(data => {
                if(data != null){
                    //user = data;
                    setStep(data);
                    setFirstRender(false);
                }
            });
        }

        if (isError) {
        toast.error(message)
        }

        if (isSuccess || stp) {
            navigate("/step2")
        }
        dispatch(reset())
  }, [step, isError, isSuccess, message, firstRender, dispatch])

    const handleInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        setStep({...step, [name]:value})
    }

    // Handle Submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        
        if(page.updated){
            if(window.confirm("Enregistrer les modifications ?")){
                setIsLoading(true);
                let {title, titleShort, resume, context, objective, result, amount, duration} = step;
                const stepData = {
                    title,
                    titleShort,
                    resume,
                    context,
                    objective,
                    result,
                    amount,
                    duration
                }
                try {
                    await setDoc(doc(db, "step2", id), {
                    ...stepData,
                    timeStamp: serverTimestamp(),
                    });
                    navigate("/step3")
                } catch (error) {
                    setIsLoading(false);
                    if(error.toString().includes("offline")){
                        window.alert('Pas de connexion internet')
                    }
                    else{
                        window.alert(error)
                    }
                }
            }
        }
        else {
            navigate("/step3")
        }
    }

    const handleSave = async (event) => {
        event.preventDefault();
        
        if(page.updated){
            setIsLoading(true);
            if(window.confirm("Enregistrer les modifications ?")){
                let {title, titleShort, resume, context, objective, result, amount, duration} = step;
                const stepData = {
                    title,
                    titleShort,
                    resume,
                    context,
                    objective,
                    result,
                    amount,
                    duration
                }
                try {
                    await setDoc(doc(db, "step2", id), {
                    ...stepData,
                    timeStamp: serverTimestamp(),
                    });
                    navigate("/dashboard")
                } catch (error) {
                    setIsLoading(false);
                    if(error.toString().includes("offline")){
                        window.alert('Pas de connexion internet')
                    }
                    else{
                        window.alert(error)
                    }
                }
            }
        }
        else{
            navigate("/dashboard")
        }
    }
    
    if (isLoading) {
        return <Spinner />
      }
      
    return (
        <div>
            <Navbar1/>
            <div className="container m-5">
                <div className="row">
                <div className='col-md-3 m-4'>
                        <div className="row cadre">
                            <p className="mt-3 pt-0 text-white fw-bolder" id="dashb">Candidature</p>
                            <div className="m-3 mt-0 mb-0">
                                <Sidebar/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 pl-4">
                        <p className="lead fs-1">{t('menu_2')}</p>
                        <p><span className="star">*</span> = {t('required')}</p>
                        <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('project_title')}</label>
                                    <input type="email" required disabled={status.submitted || deadline.value <= 0} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="title" value ={step.title} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('title_abbreviation')}</label>
                                    <input type="email" required disabled={status.submitted || deadline.value <= 0} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="titleShort" value ={step.titleShort} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('project_summary')} ({500 - res.count} {t('remaining_words')})</label>
                                    <textarea className={500 - res.count < 0?
                                        'error'
                                            :
                                        ''
                                    } name="resume" value={step.resume} required disabled={status.submitted || deadline.value <= 0} onChange={handleInput} onKeyDown={resWordCount}  id="exampleInputEmail1" cols="100" rows="10"></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('context')} ({1500 - ctx.count} {t('remaining_words')})</label>
                                    <textarea className={1500 - ctx.count < 0?
                                        'error'
                                            :
                                        ''
                                    } name="context" value={step.context} required disabled={status.submitted || deadline.value <= 0} onChange={handleInput} onKeyDown={contextWordCount} id="exampleInputEmail1" cols="100" rows="10"></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('objective')} ({1000 - obj.count} {t('remaining_words')})</label>
                                    <textarea className={1000 - obj.count < 0?
                                        'error'
                                            :
                                        ''
                                    } name="objective" required value={step.objective} disabled={status.submitted || deadline.value <= 0} onChange={handleInput} onKeyDown={objWordCount}  id="exampleInputEmail1" cols="100" rows="10"></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('expected_result')} ({1000 - res2.count} {t('remaining_words')})</label>
                                    <textarea className={1000 - res2.count < 0?
                                        'error'
                                            :
                                        ''
                                    } name="result" required value={step.result} disabled={status.submitted || deadline.value <= 0} onChange={handleInput} onKeyDown={res2WordCount}  id="exampleInputEmail1" cols="100" rows="10"></textarea>
                                </div>
                                <div className="d-flex justify-content-start">
                                    <div className="mb-3 me-4">
                                        <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('amount_requested')}</label>
                                        <input type="number" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                        name="amount" required value ={step.amount} disabled={status.submitted || deadline.value <= 0} onChange={handleInput}/>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('implementation_time')}</label>
                                        <input type="number" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                        name="duration" required value ={step.duration} disabled={status.submitted || deadline.value <= 0} onChange={handleInput}/>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <div className="col-md-8">
                                        <input type="submit" className='col-md-3 btn btn-primary' disabled={status.submitted || deadline.value <= 0} id="vehicle1" name="vehicle1" value={t('previous')} onClick={()=>{navigate("/step1")}}/>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="d-flex justify-content-end">
                                        <div className="col-md-8">
                                            <input type="submit" className='col-md-8 btn btn-primary'  id="vehicle1" name="vehicle1" value={t('save')} disabled={form.error || status.submitted} onClick={handleSave}/>
                                        </div>
                                        <div className="col-md-4">
                                            <input type="submit" className='btn btn-outline-primary'  id="vehicle1" name="vehicle1" value={t('continue')} disabled={form.error || status.submitted} onClick={handleSubmit}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="space"/>
            </div>
        </div>
    )
}

export default Step2;
